import { render, staticRenderFns } from "./ClientView.vue?vue&type=template&id=b4e89dd0"
import script from "./ClientView.vue?vue&type=script&lang=js"
export * from "./ClientView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports